<template>
  <div class="col-sm-12 col-lg-10 mx-auto mt-2">
    <h3 class="font-weight-bold">Prossimi Consulti</h3>
    <div class="col-sm-12 col-lg-10 d-flex mx-auto flex-wrap">
      <div
        class="point col-sm-12 col-md-6 col-lg-4 mx-auto d-flex mt-2"
        v-for="(consulto, ind) in consulti"
        :key="ind"
        @click="goToConsulto(consulto.hashid)"
      >
        <div
          class="col-6 ml-auto mr-0 bg-secondary border border-secondary rounded-circle round__div text__control d-flex flex-column"
        >
          <span
            class="text-white mx-auto mt-auto align-self-center font-weight-bold"
            >{{ formatDay(consulto.data_inizio) }}</span
          >

          <span
            class="text-white mx-auto mb-auto align-self-center font-weight-bold"
            >{{ consulto.data_inizio | moment("HH:mm") }}</span
          >
        </div>
        <div class="col-6 mr-auto ml-0 d-flex">
          <!-- <UserLogo class="user__logo" /> -->
          <h5 class="align-self-center m-auto font-weight-bold text-secondary">
            {{
              isPaziente
                ? consulto.professionista.anagrafica.fullname
                : consulto.paziente.anagrafica.fullname
            }}
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
// import UserLogo from "@/../public/svg/user-round.svg";
export default {
  name: "prossimi-consulti",
  props: ["isPaziente"],
  //   components: { UserLogo },
  data() {
    return {
      consulti: null,
    };
  },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    },
  },
  methods: {
    fetchData() {
      var url = process.env.VUE_APP_VERSION + "consulto/all?prossimi=3";
      this.$axios
        .get(url)
        .then((res) => {
          console.log(res.data.data);
          this.consulti = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatDay(date) {
      var giorno = moment(date);
      var now = moment();
      if (giorno.dayOfYear() == now.dayOfYear()) {
        return "Oggi";
      }
      return giorno.format("dddd DD ");
    },
    goToConsulto(id) {
      if (this.isPaziente) {
        this.$router.push({
          name: "AvvioConsultoPaziente",
          params: { rif: id },
        });
      } else {
        this.$router.push({
          name: "AvvioConsultoProfessionista",
          params: { rif: id },
        });
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
<style scoped>
.round__div {
  height: 80px;
  max-width: 80px;
}
</style>
